import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from "react";
import { useRawConversationRef, useRegisterCallbacks } from "./ConversationContext.js";
const ConversationFeedbackContext = createContext(null);
/**
 * Reads from `ConversationContext` and registers an `onCanSendFeedbackChange`
 * callback. Manages its own `canSendFeedback` state and provides it along with
 * a `sendFeedback` action through `ConversationFeedbackContext`.
 * Must be rendered inside a `ConversationProvider`.
 */
export function ConversationFeedbackProvider({ children, }) {
    const conversationRef = useRawConversationRef();
    const [canSendFeedback, setCanSendFeedback] = useState(false);
    useRegisterCallbacks({
        onCanSendFeedbackChange({ canSendFeedback: newValue }) {
            setCanSendFeedback(newValue);
        },
        onDisconnect() {
            setCanSendFeedback(false);
        },
    });
    const sendFeedback = useCallback((like) => {
        conversationRef.current?.sendFeedback(like);
    }, [conversationRef]);
    const value = useMemo(() => ({
        canSendFeedback,
        sendFeedback,
    }), [canSendFeedback, sendFeedback]);
    return (_jsx(ConversationFeedbackContext.Provider, { value: value, children: children }));
}
/**
 * Returns the current feedback state and a `sendFeedback` action.
 * Re-renders only when `canSendFeedback` changes.
 *
 * Must be used within a `ConversationProvider`.
 */
export function useConversationFeedback() {
    const ctx = useContext(ConversationFeedbackContext);
    if (!ctx) {
        throw new Error("useConversationFeedback must be used within a ConversationProvider");
    }
    return ctx;
}
//# sourceMappingURL=ConversationFeedback.js.map